// extracted by mini-css-extract-plugin
export default {"loadingContainer":"SectoralReport_loadingContainer__ayvj3"};